import { geoToH3, h3IsValid, h3ToGeoBoundary } from 'h3-js';
import React from 'react';

export class Map extends React.Component {
    constructor(props) {
        super(props);

        this.map = null;
        setTimeout(() => this.initMap(), 1000);

        this.indexMap = {}; // id,POLYGON
    }

    initMap() {
        const dom = document.getElementById("map");
        this.map = new window.google.maps.Map(dom, {
            center: { lat: 37.659101, lng: 127.059603 },
            zoom: 13
        });

        this.map.addListener('rightclick', (e) => {
            const latLng = [e.latLng.lat(), e.latLng.lng()];
            const index = geoToH3(latLng[0], latLng[1], 7);

            const boundary = h3ToGeoBoundary(index, true);
            const paths = boundary.map(pair => ({ lat: pair[1], lng: pair[0] }));

            const polygon = new window.google.maps.Polygon({
                paths,
                strokeColor: "#000000",
                strokeWeight: 2,
                fillColor: "#000000",
                fillOpacity: 0.25
            });

            polygon.addListener('rightclick', (e) => {
                polygon.setMap(null);
                delete this.indexMap[index];
                console.log(this.indexMap);
            });

            polygon.setMap(this.map);
            this.indexMap[index] = polygon;
            console.log(this.indexMap);
        });
    }

    onChangeTextarea(evt) {
        const text = evt.currentTarget.value;
        if (!text) return;

        const indexes = text.split(",");
        indexes
            .filter(idx => this.indexMap[idx] === undefined)
            .filter(idx => h3IsValid(idx))
            .forEach(index => {
                const boundary = h3ToGeoBoundary(index, true);
                const paths = boundary.map(pair => ({ lat: pair[1], lng: pair[0] }));

                const polygon = new window.google.maps.Polygon({
                    paths,
                    strokeColor: "#000000",
                    strokeWeight: 2,
                    fillColor: "#000000",
                    fillOpacity: 0.25
                });

                polygon.addListener('rightclick', (e) => {
                    polygon.setMap(null);
                    delete this.indexMap[index];
                    console.log(this.indexMap);
                });

                polygon.setMap(this.map);
                this.indexMap[index] = polygon;
                console.log(this.indexMap);
            });
    }

    render() {
        console.log("render");
        return (
            <React.Fragment>
                <div id="map" style={{ width: window.innerWidth, height: window.innerHeight }} />
                <div style={{ width: 400, height: 200, position: "absolute", left: 30, top: 30, background: "#fff" }}>
                    <textarea style={{ width: 400, height: 200 }} onChange={this.onChangeTextarea.bind(this)}></textarea>
                </div>
            </React.Fragment>
        );
    }
}
